import {Resizable} from 're-resizable'
import * as React from 'react'
import {setCookie} from '../../../core/helpers'
import {getMapService} from '../../../core/reducers/map'
interface Props {
  sidebarWidth: string
  sidebarNavigation?: (navigationWidth: number) => JSX.Element
  sidebarContent?: (long: boolean) => JSX.Element
  mainContent: JSX.Element
  minimize: boolean
  mobile: boolean
  setLong: (long: boolean) => void

  navigationWidth: number
}

interface State {
  sidebarWidth: string
  long: boolean
}

export default class CodeLayout extends React.Component<Props, State> {
  longCriteria = 800
  latestRecievedWidth: string
  constructor(props: Props) {
    super(props)
    this.state = {
      sidebarWidth: props.sidebarWidth,
      long: parseInt(props.sidebarWidth.replace('px', '')) > this.longCriteria
    }
  }

  render() {
    const minimize = this.props.minimize && this.props.sidebarNavigation
    if (minimize && getMapService()) {
      let times = 0
      const fadeRefreshing = setInterval(() => {
        getMapService().updateSize()
        if (times > 5) {
          clearInterval(fadeRefreshing)
        }
        times++
      }, 100)
    }
    const mobileOrCloseWidth = `100%`
    const mainWidth = minimize ? mobileOrCloseWidth : `calc(100% - ${this.state.sidebarWidth}`
    const mainContentStyle: React.CSSProperties = {
      width: this.props.mobile ? mobileOrCloseWidth : mainWidth,
      position: this.props.mobile ? 'absolute' : 'relative',
      height: this.props.mobile ? '100%' : '',
      right: 0
    }
    return (
      <div className="sidebar-layout">
        {this.props.sidebarContent ? (
          <Resizable
            className="code-layout-sidebar-resize"
            style={{height: '100%', transition: 'all 0.5s ease'}}
            maxWidth={minimize ? `${this.props.navigationWidth}px` : this.props.mobile ? '100%' : '40%'}
            minWidth={minimize ? '0' : '20%'}
            defaultSize={
              this.props.mobile ? {width: '100%', height: '100%'} : {width: this.state.sidebarWidth, height: '100%'}
            }
            enable={{
              right: !this.props.mobile
            }}
            onResizeStart={(e, direction, elementRef) => {
              elementRef.style.transition = ''
            }}
            onResize={(e, direction, elementRef, delta) => {
              if (elementRef.style.width) {
                this.setState({
                  sidebarWidth: elementRef.style.width,
                  long: parseInt(elementRef.style.width.replace('px', '')) > this.longCriteria
                })
                const widthNumber = parseInt(elementRef.style.width.replace('px', ''))
                if (!isNaN(widthNumber)) {
                  if (widthNumber > this.longCriteria) {
                    this.props.setLong(true)
                  } else {
                    this.props.setLong(false)
                  }
                }
              }
              if (getMapService()) {
                getMapService().updateSize()
              }
            }}
            onResizeStop={(e, direction, elementRef, delta) => {
              elementRef.style.transition = 'all 0.5s ease'
              if (elementRef.style.width) {
                this.setState({sidebarWidth: elementRef.style.width})
                setCookie('sidebarWidth', elementRef.style.width)
              }
              if (getMapService()) {
                getMapService().updateSize()
              }
            }}
          >
            <div className="code-sidebar">
              {this.props.sidebarNavigation ? this.props.sidebarNavigation(this.props.navigationWidth) : null}
              <div style={{width: `calc(100% - ${this.props.navigationWidth}px)`}}>
                {this.props.sidebarContent(this.state.long)}
              </div>
            </div>
          </Resizable>
        ) : null}
        <div className="code-main-content" style={mainContentStyle}>
          {this.props.mainContent}
        </div>
      </div>
    )
  }
}
